'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = function Row(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$node = _ref.node,
      Node = _ref$node === undefined ? 'div' : _ref$node;
  return _react2.default.createElement(
    Node,
    { className: (0, _classnames2.default)('row', className) },
    children
  );
};

Row.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  node: _react.PropTypes.node
};

exports.default = Row;


//////////////////
// WEBPACK FOOTER
// ./~/react-materialize/lib/Row.js
// module id = 64
// module chunks = 0